/**
 * Shared props for decimal inputs in the Polish-first UI.
 *
 * Ant Design treats a comma as a removable character unless the input is
 * configured explicitly. That turns an operator entry such as `156,25` into
 * `15625`, which is especially dangerous for quantities and costs.
 */
export const parsePolishDecimalInput = (displayValue?: string): string => (
  String(displayValue ?? '')
    .replace(/\s/g, '')
    .replace(',', '.')
);

export const POLISH_DECIMAL_INPUT_NUMBER_PROPS = {
  decimalSeparator: ',',
} as const;
